import { render } from "./employee-designations.vue?vue&type=template&id=e4ff44f8"
import script from "./employee-designations.vue?vue&type=script&lang=js"
export * from "./employee-designations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__